<template>
  <div class="bg-white" :style="`height:${height} !important; overflow-y: ${overflowY}` ">
    <b-row :style="``" class="px-3" >
      <b-col v-if="title != 'عنوان'" cols="12 pt-3">
      <h2 >{{ title }}</h2>
      </b-col>
      <slot></slot>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'points-table',
  props: {
    title: {
      type: String,
      default: 'عنوان',
    },
    height: {
      type: String,
    },
    overflowY: {
      type: String,
      default: 'hidden',
    },
  },
}
</script>

<style scoped lang="scss">
h2 {
  font-family: IRANSans-bold;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 23px;
  letter-spacing: 0px;
  margin: 0;
}

::-webkit-scrollbar {
  display: none;
}
</style>
